import styled from 'styled-components';
import * as Globals from '../../Globals';

export const Heading = styled(Globals.Body)`
  font-weight: 600;
  color: #282331;
`
